if (!customElements.get('video-wrapper')) {
  customElements.define(
    'video-wrapper',
    class VideoWrapper extends HTMLElement {
      constructor() {
        super();
        this.playVideos();
      }

      playVideos() {
        const videos = document.querySelectorAll(
          '.video-bg__media video'
        );

        if (!videos) {
          return;
        }

        const playVideo = (video) => {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Gesture-less autoplay of an unmuted video is blocked on mobile
              // browsers (even with playsinline). Fall back to muted playback,
              // the only autoplay these browsers allow without a user gesture.
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        };

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                playVideo(entry.target);
              } else {
                entry.target.pause();
              }
            });
          },
          {
            threshold: 0.25,
          }
        );

        videos.forEach((video) => {
          observer.observe(video);
        });
      }
    }
  );
}
